require('./bootstrap');

import Vue from 'vue';
//Rutas del website
import Router from './router.js';

//Librerias globales
import Library from './libs.js';
Vue.use(Library);

// AOS
import AOS from 'aos';
import 'aos/dist/aos.css';

Vue.config.productionTip = false;

//Componentes del website
import components from './components/components.js';
Vue.use(components);

window.Vue=Vue;

//Instancia principal
const app = new Vue({
  el: '#app',
  router:Router,

  mounted() {
    AOS.init({
      duration: 800,
      easing: 'ease-in-out',
      mirror: true,
      once: false // anima solo la primera vez
    }),

    this.$nextTick(() => {
      AOS.refresh()
    })
  },
});
